import React, { useState } from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import knickfigurenImageDE from "../../../../../../images/Knicken/20191009_Euler Beam_DE.png";
import knickfigurenImageEN from "../../../../../../images/Knicken/20191009_Euler Beam_DE.png";
import knickfigurenImageES from "../../../../../../images/Knicken/20191009_Euler Beam_ES.png";
import DickeWeicheBodenschichtImage from "../../../../../../images/Knicken/20231010_Ofner Wimmer Knickfigur.png";
import DickeWeicheBodenschicht from "../../general/DickeWeicheBodenschicht";
import Abminderungsfaktor from "./Abminderungsfaktor";
import Ausnutzung from "./Ausnutzung";
import BemessungswertDesBiegeknickwiderstand from "./BemessungswertDesBiegeknickwiderstand";
import BezogenerSchlankheitsgrad from "./BezogenerSchlankheitsgrad";
import Bezugsschlankheitsgrad from "./Bezugsschlankheitsgrad";
import Knicklaenge from "./Knicklaenge";
import Knicklaengenbeiwert from "./Knicklaengenbeiwert";
import Phi from "./Phi";
import Traegheitsradius from "./Traegheitsradius";
import HiddenWrapperRow from "../../../../../../components/UI/HiddenWrapperRow";

function Nachweis({
  expand,
  kritischeKnicklaenge,
  traegheitsradius,
  bezugsschlankheitsgrad,
  bezogenerSchlankheitsgrad,
  abminderungsfaktor,
  delta,
  biegeknickbeanspruchbarkeit,
}) {
  const { t, i18n } = useTranslation("translation");
  const hide = `${expand ? "box" : "d-sm-none"} `;

  const [showKnickfigurenImage, setShowKnickfigurenImage] = useState(false);
  const [showImage, setShowImage] = useState(false);
  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("inner.buckling.dinEN1993.verification.headline")}</h1>
        </div>
      </div>
      <div className="row">
        {/* Dicke der weichen Bodenschicht */}
        <AnimatedCol>
          <DickeWeicheBodenschicht showImage={setShowImage} show={showImage} />
        </AnimatedCol>
        <HiddenWrapperRow>
          <ShowImageDetails
            show={showImage}
            setShow={setShowImage}
            image={DickeWeicheBodenschichtImage}
          />
        </HiddenWrapperRow>
        {/* Knicklängenbeiwert */}
        <AnimatedCol>
          <Knicklaengenbeiwert show={showKnickfigurenImage} onclick={setShowKnickfigurenImage} />
        </AnimatedCol>

        {/* Knicklänge */}
        <AnimatedCol expand={expand}>
          <Knicklaenge kritischeKnicklaenge={kritischeKnicklaenge} />
        </AnimatedCol>

        {/* Trägheitsradius */}
        <AnimatedCol expand={expand}>
          <Traegheitsradius traegheitsradius={traegheitsradius} />
        </AnimatedCol>

        {/* Bezugsschlankheitsgrad */}
        <AnimatedCol expand={expand}>
          <Bezugsschlankheitsgrad bezugsschlankheitsgrad={bezugsschlankheitsgrad} />
        </AnimatedCol>

        {/* Bezogener Schlankheitsgrad */}
        <AnimatedCol expand={expand}>
          <BezogenerSchlankheitsgrad bezogenerSchlankheitsgrad={bezogenerSchlankheitsgrad} />
        </AnimatedCol>

        {/* Abminderungsfaktor */}
        <AnimatedCol expand={expand}>
          <Abminderungsfaktor abminderungsfaktor={abminderungsfaktor} />
        </AnimatedCol>

        {/* ?? Phi ?? */}
        <AnimatedCol expand={expand}>
          <Phi delta={delta} />
        </AnimatedCol>

        {/* Bemessungswert des Biegeknickwiderstandes */}
        <AnimatedCol>
          <BemessungswertDesBiegeknickwiderstand
            biegeknickbeanspruchbarkeit={biegeknickbeanspruchbarkeit}
          />
        </AnimatedCol>

        <HiddenWrapperRow>
          <ShowImageDetails
            show={showKnickfigurenImage}
            setShow={setShowKnickfigurenImage}
            image={
              i18n.language === "de-DE"
                ? knickfigurenImageDE
                : i18n.language === "es-ES"
                  ? knickfigurenImageES
                  : knickfigurenImageEN
            }
          />
        </HiddenWrapperRow>

        {/* Ausnutzung */}
        <AnimatedCol>
          <Ausnutzung />
        </AnimatedCol>
      </div>
    </div>
  );
}

function ShowImageDetails({ show, setShow, image }) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image src={image} width={"400px"} alt="" />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default Nachweis;
